import React, { useState } from "react";
import AccordionItem from "../functions/AccordionData";
import "../css/Accordion.css";


const Hargaspecial = () => {
  const [currentlyActive, setCurrentlyActive] = useState(1);

  const handleAccordionClick = (newActiveAccordion) => {
    setCurrentlyActive(
      newActiveAccordion === currentlyActive ? null : newActiveAccordion
    );
    console.log(`currently active item: ${currentlyActive}`);
    console.log(
      `newly active item: ${newActiveAccordion} previous active item ${currentlyActive}`
    );
  };

  const dalamkota = 
  <div class="container d-flex justify-align-center" >
   <table> 
    <tbody>
      <tr>
        <td style={{width:'500px'}}>Antar / Jemput Bandara/ Jakarta (all-in)</td> <td> Rp. 1.200.000</td>      
      </tr>
      <tr>
        <td >Dalam Kota Jakarta (fullday) </td> <td> Rp. 1.600.000</td>      
      </tr>
      <tr>
        <td >Bogor, Depok, Tangerang Kota, Bekasi (fullday) </td> <td> Rp. 1.800.000</td>      
      </tr>
      </tbody>
    </table>
  </div>
  ;
  const luarkota = 
  <div class="container d-flex justify-align-center" >
    <table > 
    <tbody >
      <tr >
        <td style={{width:'500px'}}> Cikarang, Tangerang, Karawaci, Cikupa</td> <td> Rp. 1.800.000</td>      
      </tr>
      <tr>
        <td >Puncak Bawah, Bogor,Taman Safari</td> <td> Rp. 1.800.000</td>      
      </tr>
      <tr>
        <td >Puncak Atas, Sukabumi Kota, Anyer  </td> <td> Rp. 1.900.000</td>      
      </tr>
      <tr>
        <td >Karawang, Cikampek, Subane, Purwakarta  </td> <td> Rp. 1.900.000</td>      
      </tr>
      <tr>
        <td >Pandeglang. Lembang, Bandung </td> <td> Rp. 2.000.000</td>      
      </tr>
      <tr>
        <td >Bandung Selatan, Sumedang, Garut, Citarik </td> <td> Rp. 2.100.000</td>      
      </tr>
      <tr>
        <td >Indramayu, Cirebon, Garut, Sumedang </td> <td> Rp. 2.100.000</td>      
      </tr>
      </tbody>
    </table>
  </div>
  ;
  const nginap = 
  <div class="container d-flex justify-align-center" >
    <table> 
    <tbody>
      <tr>
        <td style={{width:'500px'}}>Cirebon, Kuningan, Tasik, Cianjur Selatan, Minimal 2 Hari</td> <td> Rp. 1.900.000 / hari</td>      
      </tr>
      <tr>
        <td >Ujung Genteng, Pangandaran, Ciletuh, Minimal 3 Hari </td> <td> Rp. 2.000.000 / hari</td>      
      </tr>
      <tr>
        <td >Jawa Tengah, Tegal, Slawi, Brebes, Minimal 2 Hari </td> <td> Rp. 2.000.000 / hari</td>      
      </tr>
      <tr>
        <td >Jawa Tengah, Semarang, Solo, Jogia, Minimal 3 Hari </td> <td> Rp. 2.000.000 / hari</td>      
      </tr>
      <tr>
        <td >Jawa Tengah, Gunung Kidul, Pacitan, Minimal 4 Hari </td> <td> Rp. 2.000.000 / hari</td>      
      </tr>
      <tr>
        <td >Jawa Timur, Ngawi, Kediri, Pacitan Minimal 4 Hari </td> <td> Rp. 2.000.000 / hari</td>      
      </tr>
      <tr>
        <td >Jawa Timur, Surabaya, Malang, Madura Minimal 5 Hari </td> <td> Rp. 2.000.000 / hari</td>      
      </tr>
      <tr>
        <td >Jawa Timur, Jember, Banyuwangi Minimal 6 Hari </td> <td> Rp. 2.000.000 / hari</td>      
      </tr>
      <tr>
        <td >Lampung Minimal 2 Hari </td> <td> Rp. 2.000.000 / hari</td>      
      </tr>
      <tr>
        <td >Palembang Minimal 4 Hari</td> <td> Rp. 2.000.000 / hari</td>      
      </tr>
      <tr>
        <td >Jambi, Bengkulu Minimal 6 Hari</td> <td> Rp. 2.000.000 / hari</td>      
      </tr>
      <tr>
        <td >Bali, Denpasar Minimal 6 Hari</td> <td> Rp. 2.000.000 / hari</td>      
      </tr>
      <tr>
        <td >Padang, Pekanbaru Minimal 8 Hari</td> <td> Rp. 2.000.000 / hari</td>      
      </tr>
      <tr>
        <td >Medan, Lombok Minimal 10 Hari</td> <td> Rp. 2.000.000 / hari</td>      
      </tr>
      </tbody>
    </table>
  </div>;

  const mdalamkota = [
    { name: 'Antar / Jemput Bandara/ Jakarta (all-in)', price: 'Rp. 1.200.000' },
    { name: 'Dalam Kota Jakarta (fullday)', price: 'Rp. 1.600.000' },
    { name: 'Bogor, Depok, Tangerang Kota, Bekasi (fullday) ', price: 'Rp. 1.800.000' },
  
  ];

  const mluarkota = [
    { name: 'Cikarang, Tangerang, Karawaci, Cikupa', price: 'Rp. 1.800.000' },
    { name: 'Puncak Bawah, Bogor,Taman Safari', price: 'Rp. 1.800.000' },
    { name: 'Puncak Atas, Sukabumi Kota, Anyer ', price: 'Rp. 1.900.000' },
    { name: 'Karawang, Cikampek, Subane, Purwakarta  ', price: 'Rp. 1.900.000' },
    { name: 'Pandeglang. Lembang, Bandung  ', price: 'Rp. 2.000.000' },
     { name: 'Bandung Selatan, Sumedang, Garut, Citarik  ', price: 'Rp. 2.100.000' },
     { name: 'Indramayu, Cirebon, Garut, Sumedang ', price: 'Rp. 2.100.000' },
   
  ];

  const mnginap = [
    { name: 'Cirebon, Kuningan, Tasik, Cianjur Selatan, Min 2 Hari', price: 'Rp. 1.900.000' },
    { name: 'Ujung Genteng, Pangandaran, Ciletuh, Min 3 Hari', price: 'Rp. 2.000.000' },
    { name: 'Jawa Tengah, Tegal, Slawi, Brebes, Min 2 Hari', price: 'Rp. 2.000.000' },
    { name: 'Jawa Tengah, Semarang, Solo, Jogia, Min 3 Hari', price: 'Rp. 2.000.000' },
    { name: 'Jawa Tengah, Gunung Kidul, Pacitan, Mini 4 Hari', price: 'Rp. 2.000.000' },
    { name: 'Jawa Timur, Ngawi, Kediri, Min 4 Hari', price: 'Rp. 2.000.000' },
    { name: 'Jawa Timur, Surabaya, Malang, Madura, Min 5 Hari', price: 'Rp. 2.000.000' },
    { name: 'Jawa Timur, Jember, Banyuwangi, Min 6 Hari', price: 'Rp. 2.000.000' },
    { name: 'Lampung, Min 2 Hari', price: 'Rp. 2.000.000' },
    { name: 'Palembang, Min 4 Hari', price: 'Rp. 2.000.000' },
    { name: 'Jambi, Bengkulu, Min 6 Hari', price: 'Rp. 2.000.000' },
    { name: 'Bali, Denpasar, Min  6 Hari', price: 'Rp. 2.000.000' },
    { name: 'Padang, Pekanbaru, Min 8 Hari', price: 'Rp. 2.000.000' },
    { name: 'Medan, Lombok, Min 10 Hari', price: 'Rp. 2.000.000' },
     
   
  ];

   return (
    <div id="harga">

        <div className="accordion-menu">
          <h1 className="title">Harga Special</h1>
          <div className="accordion-items">
            <AccordionItem
              title="Dalam Kota"
              content= {dalamkota}
              isActive={currentlyActive === 1}
              onClick={() => handleAccordionClick(1)}
            />
            <AccordionItem
              title="Luar Kota (1 hari pulang pergi)"
              content= {luarkota}
              isActive={currentlyActive === 2}
              onClick={() => handleAccordionClick(2)}
            />
            <AccordionItem
              title="Luar Kota (Nginap)"
              content= {nginap}
              isActive={currentlyActive === 3}
              onClick={() => handleAccordionClick(3)}
            />
          </div>
           </div>
    
        <div className="table-menu">
          <div>
              <div className="titletxt"> <p>Harga Special</p></div>
          </div>
          <div className="title_text"> <p>Dalam Kota</p></div>
          <div class="tablebox" >
            <table class="tableharga"> 
                <tbody >
                {mdalamkota.map((product) => (
                  <tr key={product.name}>
                    <td class="harga_text">{product.name}</td> <td> {product.price}</td>      
                  </tr>
                ))}
                </tbody>
            </table>
          </div>
          <br></br>
          <div className="title_text"> <p>Luar Kota (1 Hari Pulang Pergi)</p></div>
          <div class="tablebox" >
            <table class="tableharga"> 
                <tbody >
                {mluarkota.map((product) => (
                  <tr key={product.name}>
                    <td class="harga_text">{product.name}</td> <td> {product.price}</td>      
                  </tr>
                ))}
                </tbody>
            </table>
          </div>
          <br></br>
          <div className="title_text"> <p>Luar Kota (Nginap)</p></div>
          <div class="tablebox" >
            <table class="tableharga"> 
                <tbody >
                {mnginap.map((product) => (
                  <tr key={product.name}>
                    <td class="harga_text">{product.name}</td> <td> {product.price}</td>      
                  </tr>
                ))}
                </tbody>
            </table>
          </div>
      </div>

    </div>
 
    

  );
};

export default Hargaspecial;